export default {
    name: 'DependencyRow',
    props: {
        dependencyLink: {
            type: Object,
            required: true
        }
    },
    computed: {
        showVersion () {
            return Boolean(this.dependencyLink.dependency?.versionPattern);
        },
        showTargetFramework () {
            return Boolean(this.dependencyLink.metadata?.targetFramework);
        }
    }
};
